<template lang="pug">
  //- 签到计划
  .card-plan
    .item(
      v-for="(item, index) in signPlanList"
      :key="index"
      :class="cardItemClass(item)"
    )
      //- 新人福利角标
      .newcomer-badge(v-if="item.newcomerSignBonusCount > 0")
        span.badge-label 新人再
        span.badge-count +{{ item.newcomerSignBonusCount }}
      .bonus
        .source(
          v-if="item.signSource"
          v-platform-expose="{ handler: handleExpose, data: item}"
        ) {{ item.signSource }}
        span.amount {{ item.amount }}
        img.coin(v-if="item.bgStyle !== 4" :src="item.icon" alt="")
      .day {{ item.text }}
</template>

<script>
import SPM from '@/pages/welfare/common/spm';

// 背景样式枚举：1=空白(待签到) / 2=高亮(今天) / 3=置灰(已签到) / 4=红包
const BG_STYLE_CLASS = {
  1: 'bg-blank',
  2: 'bg-highlight',
  3: 'bg-grey',
  4: 'bg-red-packet',
};

export default {
  name: 'SignInCardPlan',
  props: {
    signPlanList: { type: Array, default: () => [] },
  },
  methods: {
    cardItemClass(item) {
      return BG_STYLE_CLASS[item.bgStyle] || 'bg-blank';
    },
    handleExpose(_entry, item) {
      SPM.moduleExpose({
        moduleId: 'platform_portCross',
        contentId: 'platform_portCross',
        businessInfo: {
          bonusAmount: item.amount,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.card-plan {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.05rem;

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.04rem;
    position: relative;

    .newcomer-badge {
      position: absolute;
      top: -0.21rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.08rem 0.045rem;
      height: 0.25rem;
      background: url('https://m.hellobike.com/e87f3d4dd2.png') no-repeat center / 100% 100%;
      white-space: nowrap;
      z-index: 1;

      span {
        font-size: 0.12rem;
        font-family: 'PingFang SC', sans-serif;
        color: #fff;
        line-height: 1;
      }

      .badge-label {
        font-weight: 500;
      }

      .badge-count {
        font-family: "DIN Alternate Bold", sans-serif;
        font-weight: 700;
      }
    }

    .bonus {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 0.58rem;
      border-radius: 0.06rem;
      box-shadow: 0 0.005rem 0.01rem rgba(0, 0, 0, 0.04);
      padding-top: 0.08rem;
      position: relative;
      overflow: hidden;

      .source {
        position: absolute;
        top: 0;
        left: 0;
        background: #ffdf77;
        border-radius: 0.06rem 0 0.06rem 0;
        font-size: 0.1rem;
        color: #593d2b;
        line-height: 0.12rem;
        padding: 0 0.02rem;
        white-space: nowrap;
      }

      .amount {
        font-family: "DIN Alternate", sans-serif;
        font-size: 0.16rem;
        font-weight: 700;
        color: #ff3e36;
        line-height: 1.22em;
      }

      .coin {
        width: 0.2rem;
        height: 0.2rem;
        margin-top: 0.03rem;
      }
    }

    .day {
      font-size: 0.11rem;
      color: #879099;
      line-height: 1.4em;
    }

    &.bg-blank .bonus {
      background: #fff;
    }

    &.bg-highlight {
      .bonus {
        background: #fff9d9;
        border: 0.01rem solid #ffc635;
      }

      .day {
        font-weight: 500;
        color: #242729;
      }
    }

    &.bg-grey {
      opacity: 0.5;

      .bonus {
        background: rgba(255, 255, 255);
      }
    }

    &.bg-red-packet {
      .bonus {
        background-image: url('https://m.hellobike.com/e842124c_Frame%202117131557%20%281%29.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        overflow: hidden;
      }

      .bonus .amount {
        color: #fff8cb;
      }
    }
  }
}
</style>
